import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> {
  label: string;
  error?: string;
  as?: 'input' | 'textarea' | 'select';
  options?: {
    value: string;
    label: string;
  }[];
}
export const Input = forwardRef<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement, InputProps>(({
  label,
  error,
  as = 'input',
  options,
  className = '',
  ...props
}, ref) => {
  const baseInputStyles = `
      w-full bg-engage-gray2 border border-engage-gray3 rounded-sm px-4 py-3 text-engage-white 
      placeholder-engage-gray4 focus:outline-none focus:border-engage-yellow focus:ring-1 focus:ring-engage-yellow
      transition-colors duration-200
      ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
    `;
  return <div className={`flex flex-col space-y-2 ${className}`} data-id="element-79">
      <label className="text-sm font-medium text-engage-gray5" data-id="element-80">{label}</label>

      {as === 'textarea' ? <textarea ref={ref as any} className={`${baseInputStyles} min-h-[120px] resize-y`} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-81" /> : as === 'select' ? <select ref={ref as any} className={`${baseInputStyles} appearance-none`} {...props as React.SelectHTMLAttributes<HTMLSelectElement>} data-id="element-82">
          <option value="" disabled data-id="element-83">
            Select an option
          </option>
          {options?.map(opt => <option key={opt.value} value={opt.value} className="bg-engage-gray2 text-engage-white" data-id="element-84">
              {opt.label}
            </option>)}
        </select> : <input ref={ref as any} className={baseInputStyles} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-85" />}

      {error && <span className="text-sm text-red-500 mt-1" data-id="element-86">{error}</span>}
    </div>;
});
Input.displayName = 'Input';